import { DatabaseOutlined, DashboardOutlined, ReconciliationOutlined } from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "base",
    path: `${APP_PREFIX_PATH}`,
    title: "sidenav.base",
    icon: DatabaseOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "dashboard",
        path: `${APP_PREFIX_PATH}/home`,
        title: "sidenav.dashboard",
        icon: DashboardOutlined,
        breadcrumb: true,
        submenu: [],
      },

      //************************************************************************* */

      //************************************************************************* */
      // Example of a submenu
      {
        key: "feature1",
        path: `${APP_PREFIX_PATH}/feature1/list`,
        allowed_paths: [{ path: `${APP_PREFIX_PATH}/feature1/edit/.*`, title: "sidenav.some_feature" }],
        title: "sidenav.some_feature",
        icon: ReconciliationOutlined,
        breadcrumb: true,
        submenu: [],
        opened: false,
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
